<div class="vtr-widget-common-warranty" id="widget-common-warranty" role="text">
	<div class="row">
		<div class="col">
			<div class="title" id="widget-common-warranty-title" role="text">{{title}}</div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<ul class="chevron-list" *ngIf="isOnline&&(warrantyData.info.status==1 || warrantyData.info.status==0)">
				<li [ngClass]="{'orange': warrantyData.info.status==1, 'blue':warrantyData.info.status==0}">
					<div class="row item-text">
						<div id="widget-common-warranty-status-label" role="text"
							class="col title d-flex align-items-center">
							{{status.detail[warrantyData.info.status] | translate |  uppercase }}
						</div>
						<div class="col date d-flex align-items-center justify-content-end">
							<div class="item-icon status">
								<div class="icon-bkg" id="widget-common-warranty-status"
									attr.aria-label="{{warrantyData.info.status == 0 ? 'in warranty' : 'warranty expired'}}"
									role="text">
									<fa-icon [icon]="['fas', warrantyData.info.status==1?'times':'check']">
									</fa-icon>
								</div>
							</div>
						</div>
					</div>
				</li>
				<li>
					<div class="row item-text">
						<div id="widget-common-warranty-startDate-label" role="text"
							class="col subtitle d-flex align-items-center">
							{{'support.warranty.startDate' | translate}}
						</div>
						<div id="widget-common-warranty-startDate-value" role="text"
							class="col date d-flex align-items-center justify-content-end  text - lowercase">
							{{warrantyData.info.startDate | formatLocaleDate}}
						</div>
					</div>
				</li>
				<li class="bottom">
					<div class="row item-text">
						<div id="widget-common-warranty-endDate-label" role="text"
							class="col subtitle d-flex align-items-center">
							{{'support.warranty.endDate' | translate}}
						</div>
						<div id="widget-common-warranty-endDate-value" role="text"
							class="col date d-flex align-items-center justify-content-end text - lowercase">
							{{warrantyData.info.endDate | formatLocaleDate}}
						</div>
					</div>
				</li>
			</ul>
			<ul class="chevron-list" *ngIf="isOnline&&warrantyData.info.status==2">
				<li class="bottom">
					<div class="container-fluid">
						<div class="row align-items-center">
							<div class="col item-text">
								<div id="widget-common-warranty-detail" role="text"
									class="col detail text-break d-flex align-items-center">
									{{'support.warranty.subDescription2' | translate}}
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
			<ul class="chevron-list" *ngIf="!isOnline">
				<li class="bottom">
					<div class="container-fluid">
						<div class="row align-items-center">
							<div class="col item-text">
								<div id="widget-common-warranty-detail" role="text"
									class="col detail text-break d-flex align-items-center">
									{{'support.warranty.subDescription3' | translate}}
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<div class="button-box">
				<vtr-material-button
					[linkId]="'widget-common-warranty-button'"
					[isDisabled]="!isOnline"
					[heightSize]="'lg'"
					[label]="'support.warranty.viewWarrantyOptions' | translate"
					[color]="warrantyData.info.status === 1 ? 'warn':'primary'"
					(buttonClick)="onClick()">
				</vtr-material-button>
			</div>
		</div>
	</div>
</div>
